import { useState, useEffect } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Palmtree, LogOut, Menu } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { MobileMenu } from "./MobileMenu";

const links = [
  { to: "/queue", label: "Live Queue" },
  { to: "/vacations", label: "Vacations" },
  { to: "/voyagers", label: "Voyagers" },
  { to: "/mission", label: "Mission" },
  { to: "/impact", label: "Impact" },
  { to: "/partners", label: "Partners" },
];

export const Navbar = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(false), [pathname]);
  const home = user?.role === "admin" ? "/admin" : user?.role === "broker" ? "/broker" : user?.role === "coo" ? "/coo" : "/dashboard";
  const homeLabel = user?.role === "admin" ? "Control Center" : user?.role === "broker" ? "Partner Portal" : user?.role === "coo" ? "Operations" : "My Spot";
  const doLogout = async () => { nav("/"); await logout(); };
  return (
    <>
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-[#0B0F19]/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-10 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <Palmtree className="w-5 h-5 text-[#38BDF8]" />
          <span className="font-serif-lux text-xl sm:text-2xl tracking-tight">Voyage<span className="text-[#38BDF8]">Queue</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-300">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className={({ isActive }) => `transition-colors hover:text-[#38BDF8] ${isActive ? "text-[#38BDF8]" : ""}`}>
              {l.label}
            </NavLink>
          ))}
          {user && user.role === "admin" && (
            <NavLink to="/admin" data-testid="nav-admin" className="hover:text-[#38BDF8] transition-colors">Admin</NavLink>
          )}
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              {user.founder_number && <span data-testid="nav-founder-badge" className="hidden sm:inline-flex sticker !text-[10px] whitespace-nowrap">Founder #{user.founder_number}</span>}
              <Link to={home} data-testid="nav-dashboard-btn" className="btn-gold px-4 py-2 text-sm whitespace-nowrap">{homeLabel}</Link>
              <button data-testid="nav-logout-btn" onClick={doLogout} className="hidden md:inline-flex btn-ghost p-2" aria-label="Log out">
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-btn" className="hidden md:inline text-sm text-slate-300 hover:text-white px-3 whitespace-nowrap">Sign in</Link>
              <Link to="/register" data-testid="nav-join-btn" className="btn-gold px-4 py-2 text-sm whitespace-nowrap">Join<span className="hidden sm:inline"> $29/mo</span></Link>
            </>
          )}
          <button data-testid="mobile-menu-btn" onClick={() => setOpen(true)} aria-label="Open menu" aria-expanded={open} className="md:hidden p-2.5 -mr-2 text-slate-200">
            <Menu className="w-6 h-6" />
          </button>
        </div>
      </div>
    </header>
    <MobileMenu open={open} onClose={() => setOpen(false)} links={links} user={user} home={home} homeLabel={homeLabel} onLogout={doLogout} />
    </>
  );
};
